module.exports = __webpack_public_path__ + "static/media/food-detail-03.77cea6d1.svg";